import {
    SIDEBAR_LEFT_HIDE,
    SIDEBAR_RIGHT_HIDE
} from '../constants/sidebars';

export function hideLeftSidebar() {
    return {
        type: SIDEBAR_LEFT_HIDE
    }
}

export function hideRightSidebar() {
    return {
        type: SIDEBAR_RIGHT_HIDE
    }
}


// WEBPACK FOOTER //
// ./src/actions/sidebars.js